import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';

// Helper to check if mobile view
const isMobile = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 480px)').matches;

function ThankYou() {
  return (
    <div className="main-bg">
      {/* Hide hero-section on mobile */}
      {!isMobile && (
        <header className="hero-section">
          <h1 className="site-title">Thank You!</h1>
          <p className="site-tagline">We will contact you shortly.</p>
        </header>
      )}
      <div className="thankyou-section">
        <Link to="/courses" className="thankyou-btn">Back to Courses</Link>
      </div>
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Life Force Dynamics. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default ThankYou; 